import React from 'react';
import cn from 'classnames';

import IServerIncident from 'features/server/model/ServerIncident/IServerIncident';
import {getFormattedDate, secondsToFormattedString} from 'shared/lib/datetime';
import {isTranslate} from 'shared/lib/lang';
import {useServerIncidentRow} from 'features/server/model/useServerIncidentRow';
import {getServerIncidentThreshold} from 'features/server/lib/serverIncidentHelper';
import Back from 'shared/ui/icons/General/Back';
import SuccessfulMonitor from 'shared/ui/icons/SuccessfulMonitor';
import ProblemMonitor from 'shared/ui/icons/ProblemMonitor';

import ServerIncidentStatusBadge from '../ServerIncidentStatusBadge/ServerIncidentStatusBadge';
import ServerIncidentSeverityBadge from '../ServerIncidentSeverityBadge/ServerIncidentSeverityBadge';
import ServerIncidentModal from '../ServerIncidentModal/ServerIncidentModal';

import styles from './ServerIncidentRow.module.scss';

interface IServerIncidentRowProps {
    item: IServerIncident,
    hideServer?: boolean,
}

const ServerIncidentRow: React.FC<IServerIncidentRowProps> = ({
    item,
    hideServer = false,
}) => {
    const {
        isOpen,
        metricLabel,
        durationSeconds,
        serverName,
        dateFormat,
        isModalOpen,
        openModal,
        closeModal,
        onButtonClick,
    } = useServerIncidentRow(item, hideServer);

    return (
        <>
            <tr className={cn(styles.row, 'clickable')} onClick={openModal}>
                <td>
                    <div className={styles.blockStatus}>
                        {isOpen ? <ProblemMonitor/> : <SuccessfulMonitor/>}
                        <ServerIncidentStatusBadge
                            isOpen={isOpen}
                            className={cn(styles.status, isTranslate() && styles.statusTranslate)}
                        />
                    </div>
                </td>
                {!hideServer && (
                    <td>
                        <span className={styles.serverName} title={serverName}>{serverName}</span>
                    </td>
                )}
                <td>{metricLabel}</td>
                <td>{getServerIncidentThreshold(item)}</td>
                <td><ServerIncidentSeverityBadge severity={item.severity}/></td>
                <td>{getFormattedDate(item.opened_at, {format: dateFormat})}</td>
                <td>{getFormattedDate(item.closed_at, {format: dateFormat, nullValue: '—'})}</td>
                <td className={styles.duration}>{secondsToFormattedString(durationSeconds)}</td>
                <td onClick={onButtonClick}>
                    <span className={styles.icon}>
                        <Back/>
                    </span>
                </td>
            </tr>

            <ServerIncidentModal
                item={item}
                open={isModalOpen}
                handleClose={closeModal}
            />
        </>
    );
};

export default ServerIncidentRow;
